import { makeSafeFn, } from 'utils/fn';
import { openPopup, } from 'utils/window';
import { BaseStore, } from 'stores/baseStore';
import socialButtonsActions from 'actions/socialButtonsActions';

class SocialButtonsStore extends BaseStore {

  routeAction(action) {
    let { e, } = action;
    let { FACEBOOK_SHARE, TWITTER_SHARE, WHATSAPP_SHARE, COMMENTS_TOGGLE, } = socialButtonsActions.TYPES;
    switch (action.type) {
      case FACEBOOK_SHARE:
        return this.popupShare(e, { width: 500, height: 280, });
      case TWITTER_SHARE:
        return this.popupShare(e, { width: 640, height: 440, });
      case WHATSAPP_SHARE:
      case COMMENTS_TOGGLE:
      default:
        return {};
    }
  }

  popupShare(event, dimensions){
    makeSafeFn(openPopup({
      event,
      url: event.target.href,
      title: event.target.title,
      width: dimensions.width,
      height: dimensions.height,
    }));
  }
}

let socialButtonsStore = SocialButtonsStore.create();

export default socialButtonsStore;


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/socialButtonsStore.js